import { css } from "lit";

export const style = css`
	* {
		box-sizing: border-box;
	}

	:host {
		display: flex;
		flex-direction: column;
		width: 100%;
		height: 100%;
		position: relative;
	}

	og-accordion {
		height: 100%;
		border: none;
	}

	rp-mf-analytics-contexts {
		height: 100%;
	}

`;
